<template>
	<dialogModule
		width="580px"
		:title="$t('cancelOrder.cancelTitle')"
		v-if="salesVisiable"
		:dialogVisible="salesVisiable"
		top="25"
		@close="close"
	>
    <span
		slot="close"
		class="el-icon-close"
		style="color: #999; padding: 10px; margin-right: -10px; cursor: pointer"
		@click="close"
	></span>
		<div slot="content">
			<div class="cen-title" v-if="receivedAmount != 0">
				{{$t('cancelOrder.paySome')}}：<span style="color: #f8475f">{{ receivedAmount }}đ</span>，{{$t('cancelOrder.cancelSureTitle')}}
			</div>
			<div class="cen-title" v-else>{{$t('cancelOrder.notPayTips')}}</div>
      <div style="font-size: 18px;color: #999;margin: 0 40px 50px;text-align: center;" v-if="thirdCouponInfos.length">{{$t('cancelOrder.cancelTextTips')}}</div>
			<div class="btn-group row align-center space-center">
        <el-button class="cancel-btn" @click="close">{{$t('cancelOrder.cancelBtn')}}</el-button>
        <el-button class="cancel-btn" type="primary" :loading="submitLoading" @click="submit">{{$t('cancelOrder.sureBtn')}}</el-button>
			</div>
		</div>
	</dialogModule>
</template>

<script>
import dialogModule from "@/components/dialogModule.vue";
import {cancelOrdingState} from "@/libs/http/modules/posOrder";

export default {
	props: ["receivedAmount", "ordingId", "thirdCouponInfos"],
	components: {
		dialogModule,
	},
	data() {
		return {
			salesVisiable: false,
      submitLoading: false
		};
	},
	created() {
		this.salesVisiable = true;
	},
	methods: {
		close() {
			this.salesVisiable = false;
			this.$emit("close");
		},
		submit() {
      this.submitLoading = true
			const cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
			cancelOrdingState({
				orderId: this.ordingId,
				terminalId: cashierItem ? cashierItem.id : ''
			}).then(data => {
        this.salesVisiable = false;
        this.submitLoading = false;
        this.$emit("close", 'refresh');
        if(this.thirdCouponInfos.length){
          this.$confirm(data === 'Y' ? this.$t('cancelOrder.cancelSuccess') : this.$t('cancelOrder.notRebackCoupon'), this.$t('cancelOrder.tips'), {
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
          }).then(res=>{}).catch(error=>{})
        }else{
          this.$message({showClose: true, message: this.$t('cancelOrder.canceTips'), type: "success", duration: 2000});
        }
      }).catch(err => {
        this.$message({showClose: true, message: err, type: "error", duration: 2000});
        this.submitLoading = false
      });
		},
	},
};
</script>

<style lang="scss" scoped>
.cen-title {
	font-size: 24px;
	color: #333;
	margin: 50px 40px;
	text-align: center;
}

.btn-group {
	margin: 0 auto;
	padding-bottom: 20px;
	.cancel-btn {
		width: 150px;
		height: 40px;
		border-radius: 4px;
		font-size: 16px;
		text-align: center;
		cursor: pointer;
	}
}
</style>